<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Add New</h1>
    </div>

    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link> / <b>Marketing</b> /
      <router-link :to="{ name: 'newsletter-page' }">Newsletter</router-link> /
      <b>Add</b>
    </div>

    <div class="separator-breadcrumb border-top"></div>

    <div class="row">
      <div class="col-md-12 card mb-4">
        <div class="card-body">
          <form @submit.prevent="submitForm">
            <div class="col-12 mb-4">
              <label><b>Title</b></label>
              <input class="form-control" type="text" v-model="data.title" />
            </div>

            <div class="col-12 mb-4">
              <label><b>Upload</b></label>
              <small class="text-danger ml-4"
                >* Recommended image upload size 768px x 512px</small
              ><br />
              <input
                type="file"
                ref="file"
                class="inputfile"
                v-on:change="handleFileUpload"
              />
            </div>

            <div class="col-12 mb-4">
              <label><b>Description</b></label>
              <ckeditor
                :editor="editor"
                v-model="data.description"
                :config="editorConfig"
              ></ckeditor>
            </div>

            <div class="col-12 mb-4">
              <label><b>Link</b></label>
              <input class="form-control" type="text" v-model="data.link" />
            </div>

            <div class="col-12 mb-4">
              <label><b>Status</b></label>
              <div class="row">
                <label class="radio radio-success ml-3">
                  <input
                    type="radio"
                    name="activeStatus"
                    v-model="data.status"
                    v-bind:value="a"
                  />
                  <span>Active</span>
                  <span class="checkmark"></span>
                </label>
                <label class="radio radio-danger ml-3">
                  <input
                    type="radio"
                    name="activeStatus"
                    v-model="data.status"
                    v-bind:value="b"
                  />
                  <span>Inactive</span>
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>

            <div class="text-center">
              <button
                type="submit"
                class="btn btn-primary btn-wide mt-4 btn-rounded"
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { storeNewsletter } from "../../../services/NewsletterService";
export default {
  components: { ckeditor: CKEditor.component },

  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {},

      checkBoxInputs: [
        { value: 1, name: "Black" },
        { value: 2, name: "Platinum" },
        { value: 3, name: "Gold" },
        { value: 4, name: "Silver" }
      ],

      a: 1,
      b: 0,

      data: {
        title: "",
        upload: "",
        image_url: "",
        link: "",
        description: "",
        status: 1
      }
    };
  },

  methods: {
    handleFileUpload() {
      this.data.upload = this.$refs.file.files[0];
    },

    async submitForm() {
      const dataForm = new FormData();

      dataForm.append("image_upload[]", this.data.upload);
      dataForm.append("title", this.data.title);
      dataForm.append("description", this.data.description);
      dataForm.append("link", this.data.link);
      dataForm.append("status", this.data.status);

      try {
        const response = await storeNewsletter(dataForm);

        swal({
          title: response.data.success ? "Success" : "Failed",
          icon: response.data.success ? "success" : "error",
          text: response.data.message
        });

        if (response.data.success) {
          this.$router.push({ name: "newsletter-page" });
        }
      } catch (e) {
        console.error(e);
      }
    }
  },

  async mounted() {}
};
</script>

<style scoped>
input[type="file"]::file-selector-button {
  margin-right: 20px;
  border: none;
  padding: 10px 20px;
  border-radius: 10px;
  color: #fff;
  background-color: #ac8400;
  border-color: #ac8400;

  /* cursor: pointer; */
  transition: background 0.2s ease-in-out;
}

input[type="file"]::file-selector-button:hover {
  color: #fff;
  background-color: #806200;
  border-color: #b38900;
}
</style>
